<template>
    <div class="UpgradeToGold">
      <div>Answer the Question Papers asked in the Previous Years in your target exam </div>
      <div>
        <v-card>
          2016 - 2020 NEET PAPERS
        </v-card>
        <v-card>
          <ul>
            <li>Last 5 years Ppaers of NEET (& AIPMT)</li>
            <li>Evaluate yourself with actual questions.</li>
            <li>Last 5 years Ppaers of NEET (& AIPMT)</li>
            <li>Evaluate yourself with actual questions.</li>
          </ul>
          <div> ₹ 99/-</div>
        </v-card>
        <v-btn  type="button" class="right-btn cust-btn" color="primary">Added</v-btn>
         <v-btn  type="button" class="right-btn cust-btn" color="primary">Buy Now</v-btn>
      </div>
       <div>
        <v-card>
          2020 JEE MAIN PAPERS
        </v-card>
        <v-card>
          <ul>
            <li>Real Examination Experience with actual questions</li>
            <li>16 Papers of JEE MAIN 2020</li>
            <li>Answer anytime you want</li>
            <li>All India Rank Prediction</li>
            <li>Identify areas of improvement</li>
          </ul>
          <div> ₹ 299/-</div>
        </v-card>
        <v-btn  type="button" class="right-btn cust-btn" color="primary">Added</v-btn>
         <v-btn  type="button" class="right-btn cust-btn" color="primary">Buy Now</v-btn>
      </div>
       <div>
        <v-card>
          2016 - 2020 JEE ADVANCED PAPERS
        </v-card>
        <v-card>
          <ul>
            <li>Last 5 years Papers of JEE ADVANCED - total 10 papers</li>
            <li>Real Examination Experience with actual questions</li>
            <li>Answer anytime you want</li>
            <li>All India Rank Prediction</li>
            <li>Identify areas of improvement</li>
            <li>All India Rank Prediction</li>
          </ul>
          <div> ₹ 199/-</div>
        </v-card>
        <v-btn  type="button" class="right-btn cust-btn" color="primary">Added</v-btn>
         <v-btn  type="button" class="right-btn cust-btn" color="primary">Buy Now</v-btn>
      </div>
      
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import constants from "@/utils/constants.js";
//import Subscription from "@/views/pages/Subscription/Subscription.vue";
//import PackagesList from "@/components/student/UpgradeToGold/PackagesList.vue";
export default {
    name: "ReadyMadeTestUpgrade",
    //props: ["parentId", "subType"],
    data() {
        return {
           

        }
    },
    
    components: {
        //PackagesList,
		//Subscription
    },
    mounted() {},
    computed: {
        // ...mapState("userStore", ["user"])
    },
    methods: {
      
     
    }
};
</script>
